/**
 * Gallery component.
 */

define('libs/gallery',['require','libs/utilities.touch.swipe','libs/utilities.throttle'],function(require) {

    'use strict';

    var SwipeListener = require('libs/utilities.touch.swipe'),
        throttle = require('libs/utilities.throttle');

    var SETTINGS = {
        gridPositions: 5,
        mainPosition: 3,
        animationTime: 400,
        mobileBreakpoint: 760,
        pictureSelector: '.photo-element',
        btnNextSelector: '.btn-right',
        btnPrevSelector: '.btn-left',
        containerSelector: '',
        indicator: false
    };

    /**
     * Initialize the gallery.
     * @param {jQuery} $root The root element for the gallery.
     * @param {Object | *} settings The settings for the gallery.
     * @constructor
     */
    var Gallery = function($root, settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.$root = $root;
        var items = this.$root.find(this.settings.pictureSelector);

        this.allItems = [];
        for (var i = 0; i < items.length; i++) {
            this.allItems.push(items.eq(i));
            this.allItems[i].data('position', i);
            if (i == this.settings.mainPosition - 1) {
                this.allItems[i].addClass('active');
            }
        }

        var $container = this.settings.containerSelector ?
            this.$root.closest(this.settings.containerSelector) : this.$root.parent();
        // initialize the controls.
        $container.find(this.settings.btnNextSelector).on('click', this.next.bind(this));
        $container.find(this.settings.btnPrevSelector).on('click', this.prev.bind(this));

        new SwipeListener(this.$root);
        this.$root.on('swipe', this.onSwipe.bind(this));

        // enable keyboard navigation.
        this.startKeyboardListener();

        // for mobile, there's a different animation.
        this.IS_MOBILE = (document.documentElement || document.body).clientWidth <= this.settings.mobileBreakpoint;
        this.position = 0;

        if (!this.IS_MOBILE) {
            // get all the positions in the grid.
            this.positions = this.getGridPositions();

            var resizeHandler = new throttle(this.reset.bind(this), 100);
            // recalculate the grid on window resize.
            $(window).on('resize', resizeHandler);
        } else {
            this.$root.css('width', items.length * items.eq(0).width());
        }

        if (this.settings.indicator) {
            this.indicator = $(this.settings.indicator);
            this.indicator.html((this.position + 1) + '/' + this.allItems.length);
        }
    };

    Gallery.prototype.startKeyboardListener = function() {
        this.keyboardListener = function(event) {
            if (this.isMoving) {
                return true;
            }
            // arrow left.
            if (event.keyCode == 37) {
                this.prev(event);
            // arrow right.
            } else if (event.keyCode == 39) {
                this.next(event);
            }
        }.bind(this);

        $(document).on('keydown', this.keyboardListener);
    };

    Gallery.prototype.stopKeyboardListener = function() {
        $(document).off('keydown', this.keyboardListener);
    };

    Gallery.prototype.onSwipe = function(event, data) {
        if (data.direction == 'right') {
            this.prev(event);
        } else if (data.direction == 'left') {
            this.next(event);
        }
    };

    /**
     * Reset the grid when the window resizes.
     * Calculate the new grid positions.
     */
    Gallery.prototype.reset = function() {
        for (var i = 0; i < this.allItems.length; i++) {
            // reset the dimensions and position.
            this.allItems[i].css({
                top: '',
                left: '',
                height: '',
                width: ''
            });

            // reset the grid index.
            this.allItems[i].data('position', i);
        }

        // recalculate all the positions in the grid.
        this.positions = this.getGridPositions();
    };


    /**
     * Get all the positions in the grid.
     * @return {grid: [positions], positionStart: {}, positionEnd: {}}
     *  The positions for all the items in the grid.
     */
    Gallery.prototype.getGridPositions = function() {
        var positions = {
                grid: []
            },
            rect_root = this.$root[0].getBoundingClientRect(),
            rect;

        for (var i = 0; i < this.settings.gridPositions; i++) {
            rect = this.allItems[i][0].getBoundingClientRect();
            positions.grid.push({
                top: rect.top - rect_root.top,
                left: rect.left - rect_root.left,
                height: rect.height,
                width: rect.width
            });
        }

        // add last grid position that moves the picture outside the gallery.
        var lastGridPosition = positions.grid[this.settings.gridPositions - 1];
        positions.positionEnd = {
            top: lastGridPosition.top - lastGridPosition.height,
            left: lastGridPosition.left,
            height: rect.height,
            width: rect.width
        };

        // add first grid position that moves the picture from outside the gallery to position 1.
        positions.positionStart = {
            top: positions.grid[0].top + positions.grid[0].height,
            left: positions.grid[0].left,
            height: rect.height,
            width: rect.width
        };

        return positions;
    };

    /**
     * Move all the items in the grid to their next position.
     */
    Gallery.prototype.next = function(event) {
        event.preventDefault();

        this.position = this.position < this.allItems.length - 1 ? this.position + 1 : 0;
        if (this.settings.indicator) {
            this.indicator = $(this.settings.indicator);
            this.indicator.html((this.position + 1) + '/' + this.allItems.length);
        }

        if (this.IS_MOBILE) {
            this.next_mobile();
        } else {
            var itemPos,
                afterMove = function(item, position) {
                    // move item to start position.
                    item.css(position);
                };

            // move all the items to their next position.
            for (var i = 0; i < this.allItems.length; i++) {
                itemPos = this.allItems[i].data('position');
                // last item, move to positionStart
                if (itemPos == (this.settings.gridPositions - 1)) {
                    this.moveToPosition(this.allItems[i],
                        this.positions.positionEnd,
                        afterMove.bind(this, this.allItems[i], this.positions.positionStart));

                    // set the items at the back of the queue
                    this.allItems[i].data('position', this.allItems.length - 1);

                } else if (itemPos == (this.settings.gridPositions)) {
                    this.moveToPosition(this.allItems[i], this.positions.grid[0]);
                    this.allItems[i].data('position', 0);
                } else {
                    // if itemPos is a grid position, move it there
                    if (itemPos < this.settings.gridPositions - 1) {
                        this.moveToPosition(this.allItems[i], this.positions.grid[itemPos + 1]);
                        this.allItems[i].data('position', itemPos + 1);
                    } else {
                        // set the items new position in the queue
                        this.allItems[i].data('position', itemPos - 1);
                    }

                }
            }
        }
    };

    /**
     * Move all the items in the grid to their prev position.
     */
    Gallery.prototype.prev = function(event) {
        event.preventDefault();

        this.position = this.position > 0 ? this.position - 1 : this.allItems.length - 1;
        if (this.settings.indicator) {
            this.indicator = $(this.settings.indicator);
            this.indicator.html((this.position + 1) + '/' + this.allItems.length);
        }

        if (this.IS_MOBILE) {
            this.prev_mobile();
        } else {
            var itemPos,
                beforeMove = function(item, position) {
                    // move item to start position.
                    item.css(position);
                };

            // move all the items to their next position.
            for (var i = this.allItems.length - 1; i >= 0; i--) {
                itemPos = this.allItems[i].data('position');

                // last item in the queue, move to end position and animate into last grid position.
                if (itemPos === this.allItems.length - 1) {
                    this.moveToPosition(this.allItems[i],
                        this.positions.grid[this.settings.gridPositions - 1],
                        null,
                        beforeMove.bind(this, this.allItems[i], this.positions.positionEnd));
                    this.allItems[i].data('position', this.settings.gridPositions - 1);
                }
                else if (itemPos === 0) {
                    this.moveToPosition(this.allItems[i], this.positions.positionStart);
                    this.allItems[i].data('position', this.settings.gridPositions);
                }
                else if (itemPos < this.settings.gridPositions) {
                    this.moveToPosition(this.allItems[i], this.positions.grid[itemPos - 1]);
                    this.allItems[i].data('position', itemPos - 1);
                }
                else {
                    this.allItems[i].data('position', itemPos + 1);
                }
            }
        }
    };

    /**
     * Show the next item in the mobile layout.
     */
    Gallery.prototype.next_mobile = function() {
        this.atStart = false;
        this.position = this.position < this.allItems.length - 1 ? this.position + 1 : this.position;
        var left = -this.position * this.allItems[0].width(),
            callback = null,
            time = this.settings.animationTime;

        if (this.atEnd) {
            // do a little "you're at the end" animation.
            left = -((this.position) * this.allItems[0].width()) - 50;
            time = time / 3;
            callback = function() {
                this.$root.animate({
                    left: -this.position * this.allItems[0].width()
                }, this.settings.animationTime / 3);
            }.bind(this);
        }

        this.atEnd = this.position == this.allItems.length - 1;

        this.$root.animate({
            left: left
        }, time, callback);
    };

    /**
     * Show the previous item in the mobile layout.
     */
    Gallery.prototype.prev_mobile = function() {
        this.atEnd = false;
        this.atStart = this.position == 0;
        this.position = this.position > 0 ? this.position - 1 : this.position;
        var left = -this.position * this.allItems[0].width(),
            callback = null,
            time = this.settings.animationTime;

        if (this.atStart) {
            // do a little "you're at the end" animation.
            left = -((this.position) * this.allItems[0].width()) + 50;
            time = time / 3;
            callback = function() {
                this.$root.animate({
                    left: -this.position * this.allItems[0].width()
                }, this.settings.animationTime / 3);
            }.bind(this);
        }

        this.$root.animate({
            left: left
        }, time, callback);
    };

    /**
     * Move an item to its next position in the grid.
     * @param {jQuery} item The item to move.
     * @param {Object} position The new position for the item.
     * @param {Function | *} callback Function to execute after the animation.
     * @param {Function | *} beforeStart Function to execute before the animation.
     */
    Gallery.prototype.moveToPosition = function(item, position, callback, beforeStart) {
        if (typeof beforeStart == 'function') {
            beforeStart();
        }
        this.isMoving = true;

        var pos = this.positions.grid.indexOf(position);
        if (pos == this.settings.mainPosition - 1) {
            item.addClass('active');
        } else {
            item.removeClass('active');
        }

        item.animate(position, {
            duration: this.settings.animationTime,
            complete: function() {
                this.isMoving = false;
                if (typeof callback == 'function') {
                    callback.apply(this);
                }
            }.bind(this)
        });
    };


    return Gallery;
});

